/* global axios */

const agentBusinessHoursAccessAPI = {
  get(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/agent_business_hours_access`
    );
  },
};

export default agentBusinessHoursAccessAPI;
